import { MutationTree } from 'vuex';
import { IDataState } from '@/store/modules/data/state';
import { MutationTypes } from './mutation-types';

export default {
  [MutationTypes.SET_DATA](state: IDataState, data: any) {
    state.data = data;
  },
  [MutationTypes.SET_LOCATION](state: IDataState, location: any) {
    state.location = location;
  },
  [MutationTypes.SET_PAGE](state: IDataState, page: any) {
    state.page = page;
  },
} as MutationTree<any>;
